import { Tooltip, Zoom, IconButton } from '@mui/material';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import { useIntl } from 'react-intl';
import { LocalizationIds } from 'helpers/Localizations';


interface IProps {
    onClick: () => void
    stopPropagation?: boolean
}

let DeleteIconButton = ({ onClick, stopPropagation }: IProps) => {
    let { formatMessage } = useIntl();
    return (
        <Tooltip title={formatMessage({ id: LocalizationIds.Delete })} TransitionComponent={Zoom}>
            <IconButton
                size="small"
                color="error"
                onClick={(ev: any) => {
                    if (stopPropagation === true) {
                        ev.stopPropagation();
                    }
                    onClick();
                }}
            >
                <DeleteIcon />
            </IconButton>
        </Tooltip>
    )
}

export default DeleteIconButton;